import React from 'react';
import PropTypes from 'prop-types';
import { isRelationshipToVeteran, isYes } from '../../utils/helpers';

export const MarriageHistoryAccordionItem = ({ formData }) => {
  if (isRelationshipToVeteran(formData) !== 'spouse') {
    return null;
  }
  // Surviving spouse is guaranteed above; show divorce decree if not married at death, or either hadPreviousMarriages gate is true
  const showDivorceDecree =
    !isYes(formData?.marriedToVeteranAtTimeOfDeath) ||
    isYes(formData?.hadPreviousMarriages?.claimant) ||
    isYes(formData?.hadPreviousMarriages?.veteran);
  const showCourtOrder = isYes(formData?.courtOrderedSeparation);
  const showMoreThanOneRemarriage =
    isYes(formData?.claimantHasAdditionalMarriages) &&
    isYes(formData?.remarriedAfterVeteralDeath);
  const veteranMarriagesCount = formData?.veteranMarriages?.length || 0;
  const spouseMarriagesCount = formData?.spouseMarriages?.length || 0;
  // hadPreviousMarriages gates ensure stale array data isn't shown if the user unchecked the gate
  const showSpousePreviousMarriages =
    spouseMarriagesCount >= 2 && formData?.hadPreviousMarriages?.claimant;
  const showVeteranPreviousMarriages =
    veteranMarriagesCount >= 2 && formData?.hadPreviousMarriages?.veteran;
  return (
    <va-accordion-item level={5} bordered header="Marriage history">
      <p>You’ll need to submit these documents:</p>
      <ul>
        <li>Marriage license or proof of marriage</li>
        {showDivorceDecree && <li>Divorce decree</li>}
        {showCourtOrder && (
          <li>A copy of the court order that shows your separation</li>
        )}
        {showMoreThanOneRemarriage && (
          <li>
            <strong>
              For each additional marriage after the Veteran’s death
            </strong>{' '}
            you’ll need to submit a Statement in Support of Claim (VA Form
            21-4138) for every marriage after the Veteran’s death
            <span className="vads-u-display--block">
              <va-link
                href="https://www.va.gov/find-forms/about-form-21-4138"
                external
                text="Get VA Form 21-4138 to download"
              />
            </span>
          </li>
        )}
        {showSpousePreviousMarriages && (
          <li>
            <strong>If you had more than 2 previous marriages</strong>, you’ll
            need to submit one of these documents.
            <ul>
              <li>
                Statement in Support of Claim (VA Form 21-4138)
                <span className="vads-u-display--block">
                  <va-link
                    href="https://www.va.gov/find-forms/about-form-21-4138"
                    external
                    text="Get VA Form 21-4138 to download"
                  />
                </span>
              </li>
              <li>
                Application Request to Add and/or Remove Dependents (VA Form
                21-686c)
                <span className="vads-u-display--block">
                  <va-link
                    href="https://www.va.gov/manage-dependents/add-remove-form-21-686c-674"
                    external
                    text="Add or remove dependents on VA benefits"
                  />
                </span>
                <span className="vads-u-display--block">
                  <va-link
                    href="https://www.va.gov/find-forms/about-form-21-686c"
                    external
                    text="Get VA Form 21-686c to download"
                  />
                </span>
              </li>
            </ul>
          </li>
        )}
        {showVeteranPreviousMarriages && (
          <li>
            <strong>If the Veteran had more than 2 previous marriages</strong>,
            you’ll need to submit one of these documents.
            <ul>
              <li>
                Statement in Support of Claim (VA Form 21-4138)
                <span className="vads-u-display--block">
                  <va-link
                    href="https://www.va.gov/find-forms/about-form-21-4138"
                    external
                    text="Get VA Form 21-4138 to download"
                  />
                </span>
              </li>
              <li>
                Application Request to Add and/or Remove Dependents (VA Form
                21-686c)
                <span className="vads-u-display--block">
                  <va-link
                    href="https://www.va.gov/manage-dependents/add-remove-form-21-686c-674"
                    external
                    text="Add or remove dependents on VA benefits"
                  />
                </span>
                <span className="vads-u-display--block">
                  <va-link
                    href="https://www.va.gov/find-forms/about-form-21-686c"
                    external
                    text="Get VA Form 21-686c to download"
                  />
                </span>
              </li>
            </ul>
          </li>
        )}
      </ul>
    </va-accordion-item>
  );
};

MarriageHistoryAccordionItem.propTypes = {
  formData: PropTypes.object,
};
